import { useState } from 'react';

const faqs = [
  {
    question: '什么是"人善交"的理念？',
    answer: '人善交是一种人生智慧，强调在交往过程中主动选择与品德高尚、心地善良的人建立联系。它不仅关乎社交选择，更是一种对美好生活的追求，帮助人们建立高质量社交圈，远离消耗型关系。'
  },
  {
    question: '如何辨别身边真正善良的人？',
    answer: '可以从几个方面观察：他们对待弱者的态度、在背后谈论他人的方式、在冲突中的表现、是否言行一致，以及与他们相处时你的能量感受。真正善良的人在所有场合都保持一致，不会因对象不同而改变态度。'
  },
  {
    question: '为什么要远离消耗型关系？',
    answer: '消耗型关系会让你感到疲惫、焦虑和自我怀疑，长期处于这种关系中会损害你的自信心和心理健康。告别人际关系中的消耗，才能为健康的关系和更好的自己腾出空间。'
  },
  {
    question: '如何在职场中建立良好的人际关系？',
    answer: '职场关系需要在"专业能力"和"友善人格"之间找到平衡。先做好本职工作，再经营人际关系；保持适当边界；公平对待每个人；学会在必要时说"不"；以建设性的方式化解冲突。'
  },
  {
    question: '"人善交"是否意味着要排斥某些人？',
    answer: '人善交并非鼓励排斥，而是提醒我们在有限的时间和精力中，有意识地选择与那些能带来正面影响的人深入交往。对所有人都应保持基本的尊重和礼貌，但深度关系需要有所选择。'
  },
  {
    question: '如何从零开始建立高质量的社交圈？',
    answer: '首先明确你的社交目标，然后主动走出舒适区参加各种线下和线上活动。同时提升自己的社交吸引力——培养兴趣、提升沟通能力。建立关系后要有耐心经营，从浅入深。建立后还要定期维护和筛选。'
  }
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900"
            style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            关于人善交，你可能想了解的问题
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-background-200/60 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}